export const GET_ALL_MATCHED_CANDIDATES_RESET = 'GET_ALL_MATCHED_CANDIDATES_RESET';
export const GET_ALL_MATCHED_CANDIDATES_REQUEST = 'GET_ALL_MATCHED_CANDIDATES_REQUEST';
export const GET_ALL_MATCHED_CANDIDATES_SUCCESS = 'GET_ALL_MATCHED_CANDIDATES_SUCCESS';
export const GET_ALL_MATCHED_CANDIDATES_FAILURE = 'GET_ALL_MATCHED_CANDIDATES_FAILURE';

export const DELETE_MATCHED_CANDIDATES_SUCCESS = 'DELETE_MATCHED_CANDIDATES_SUCCESS';

export const GET_MATCHED_CANDIDATES_LOCATIONS_SUCCESS = 'GET_MATCHED_CANDIDATES_LOCATIONS_SUCCESS';
export const CHANGE_MATCHED_CANDIDATES_LOCATIONS_SUCCESS = 'CHANGE_MATCHED_CANDIDATES_LOCATIONS_SUCCESS';
